{
  "appName": "Платформа управления сотрудниками",
  "actions": {
    "save": "Сохранить",
    "saving": "Сохранение…",
    "cancel": "Отмена",
    "delete": "Удалить",
    "deleting": "Удаление…",
    "edit": "Изменить",
    "create": "Создать",
    "retry": "Повторить",
    "refresh": "Обновить",
    "export": "Экспорт",
    "dismiss": "Закрыть",
    "done": "Готово",
    "restore": "Восстановить",
    "restoring": "Восстановление…",
    "signOut": "Выйти",
    "changePassword": "Изменить пароль",
    "activate": "Активировать",
    "activating": "Активация…",
    "deactivate": "Деактивировать",
    "deactivating": "Деактивация…",
    "copy": "Копировать",
    "upload": "Загрузить",
    "uploading": "Загрузка…",
    "approve": "Одобрить",
    "approving": "Одобрение…",
    "reject": "Отклонить",
    "rejecting": "Отклонение…",
    "openMenu": "Открыть меню",
    "closeMenu": "Закрыть меню",
    "openUserMenu": "Открыть меню пользователя",
    "language": "Язык",
    "selectLanguage": "Выбрать язык",
    "selectAll": "Выбрать все",
    "close": "Закрыть",
    "backToHome": "На главную"
  },
  "aria": {
    "loadingApplication": "Загрузка приложения",
    "loading": "Загрузка…",
    "searchEmployees": "Поиск сотрудников"
  },
  "status": {
    "active": "Активен",
    "inactive": "Неактивен",
    "deleted": "Удалён"
  },
  "table": {
    "name": "Имя",
    "description": "Описание",
    "status": "Статус",
    "actions": "Действия",
    "email": "Email",
    "role": "Роль",
    "date": "Дата",
    "note": "Примечание",
    "noData": "Нет данных",
    "failedToLoad": "Не удалось загрузить",
    "created": "Создан"
  },
  "pagination": {
    "previous": "Назад",
    "next": "Вперёд",
    "pageOf": "Страница {{current}} из {{total}}",
    "records": "Записи:",
    "previousPage": "Предыдущая страница",
    "nextPage": "Следующая страница"
  },
  "filters": {
    "from": "С",
    "to": "По",
    "search": "Поиск...",
    "clearFilters": "Сбросить фильтры",
    "allEmployees": "Все сотрудники",
    "employee": "Сотрудник",
    "timeRange": "Период"
  },
  "form": {
    "optional": "(необязательно)",
    "unassigned": "(Не назначен)",
    "active": "Активен"
  },
  "errors": {
    "unexpectedError": "Произошла непредвиденная ошибка. Пожалуйста, попробуйте снова.",
    "saveFailed": "Не удалось сохранить",
    "loadFailed": "Не удалось загрузить данные. Пожалуйста, попробуйте снова.",
    "connectionError": "Проверьте подключение и попробуйте снова."
  },
  "nav": {
    "mainNavigation": "Основная навигация",
    "platformNavigation": "Навигация платформы"
  }
}
